import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { createStepProgress } from './step-progress';

export function initStepsSlider() {
    const sliderElements = document.querySelectorAll('.steps-slider');
    
    sliderElements.forEach((sliderElement) => {
        const section = sliderElement.closest('section');
        const prevButton = section.querySelector('.steps-prev');
        const nextButton = section.querySelector('.steps-next');
        const stepIndicator = section.querySelector('.steps-indicator');
        
        const progress = createStepProgress(section);
        
        // Function to update step indicator
        const updateStepIndicator = (activeIndex) => {
            if (stepIndicator) {
                const slides = sliderElement.querySelectorAll('.swiper-slide');
                const currentStep = slides[activeIndex];
                const stepNumber = activeIndex + 1;
                const stepTitle = currentStep?.dataset.stepTitle || '';
                
                // Fade out
                stepIndicator.style.opacity = '0';
                
                // Update content after fade out
                setTimeout(() => {
                    stepIndicator.innerHTML = `${dictionary.step} ${stepNumber}. <strong>${stepTitle}</strong>`;
                    // Fade in
                    stepIndicator.style.opacity = '1';
                }, 150);
            }
        };
        
        const swiper = new Swiper(sliderElement, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            loop: false,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            on: {
                slideChange: function() {
                    updateStepIndicator(this.activeIndex);
                    progress.updateStepProgress(this.activeIndex);
                }
            }
        });
        
        // Add click handlers to step items
        progress.stepItems.forEach((item, index) => {
            item.style.cursor = 'pointer';
            item.addEventListener('click', () => {
                swiper.slideTo(index);
            });
        });
        
        // Initialize with first slide
        updateStepIndicator(0);
        progress.updateStepProgress(0);
    });
}
